import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";

const URL_RE = /(https?:\/\/[^\s]+)/i;

export function firstUrl(text) {
  const m = (text || "").match(URL_RE);
  return m ? m[1].replace(/[)\].,]+$/, "") : "";
}

// Fetches Open Graph data (title/description/image) for the first link in the
// caption, but only when no image is attached (that's when networks unfurl the
// link into a card). Debounced so we don't hammer the endpoint while typing.
export function useLinkPreview(text, hasImage) {
  const [lp, setLp] = useState(null);
  useEffect(() => {
    const url = firstUrl(text);
    if (hasImage || !url) { setLp(null); return; }
    let cancelled = false;
    const t = setTimeout(() => {
      adminApi.metricool
        .linkPreview(url)
        .then((d) => { if (!cancelled) setLp(d); })
        .catch(() => { if (!cancelled) setLp(null); });
    }, 600);
    return () => { cancelled = true; clearTimeout(t); };
  }, [text, hasImage]);
  return lp;
}
